import request from "@/service";

/* 查询专题资源配置列表 */
export function getSubjectConfigList(params) {
  return request({
    url: `/resource/subjectBlock/config/page`,
    method: "get",
    params
  });
}

/* 专题资源配置新增 */
export function saveSubjectConfig(params) {
  return request({
    url: `/resource/subjectBlock/config/save`,
    method: "post",
    data: params
  });
}

/* 根据模块id查询视频资源配置 */
export function getRVideo(uuid) {
  return request({
    url: `/resource/subjectBlock/config/getVideoBySubjectBlockId/${uuid}`,
    method: "get"
  });
}

/* 根据模块id查询新闻资源配置 */
export function getRNews(uuid) {
  return request({
    url: `/resource/subjectBlock/config/getNewsBySubjectBlockId/${uuid}`,
    method: "get"
  });
}
/* 根据模块id查询图书资源配置 */
export function getRBooks(uuid) {
  return request({
    url: `/resource/subjectBlock/config/getBookBySubjectBlockId/${uuid}`,
    method: "get"
  });
}

/* 根据模块id查询期刊文章资源配置 */
export function getRRArticles(uuid) {
  return request({
    url: `/resource/subjectBlock/config/getPeriodicalBySubjectBlockId/${uuid}`,
    method: "get"
  });
}

/* 专题资源配置修改 */
export function updateSubjectConfig(params) {
  return request({
    url: `/resource/subjectBlock/config/update`,
    method: "put",
    data: params
  });
}

/* 专题资源配置删除 */
export function deleteSubjectConfig(params) {
  return request({
    url: `/resource/subjectBlock/config/delete`,
    method: "delete",
    data: params
  });
}

/* 拖拽排序 */
export function updateOrderByDrag(params) {
  return request({
    url: `resource/subjectBlock/config/updateOrderByDrag`,
    method: "put",
    data: params
  });
}

/* 专题版本详情 */
export function getSubjectBlockInfo(uuid) {
  return request({
    url: `/resource/subject/block/info/${uuid}`,
    method: "get"
  });
}

/* 是否最新-wangchao */
export function updateNew(params) {
  return request({
    url: `/resource/subjectBlock/config/updateNew`,
    method: "post",
    data: params
  });
}

/* 展开收起显示-wangchao */
export function updateSpreadType(params) {
  return request({
    url: `/resource/subjectBlock/config/updateSpreadType`,
    method: "post",
    data: params
  });
}